module.exports = __webpack_public_path__ + "img/facebook.dc95ea32.svg";